import { apiClient } from "../../apiClient";
import { UserSidebarResponse, SidebarMenu } from "../auth/type";

interface CreateMenuRequest {
  menu_name: string;
  route_path: string;
}

export const sidebarService = {
  async getMySidebar(): Promise<UserSidebarResponse> {
    const response = await apiClient.get<UserSidebarResponse>(
      "/sidebar-menu/my-sidebar",
    );
    return response.data;
  },

  async getAllMenus(): Promise<SidebarMenu[]> {
    const response = await apiClient.get<SidebarMenu[]>("/sidebar-menu/menus");
    return response.data;
  },

  async createMenu(data: CreateMenuRequest): Promise<SidebarMenu> {
    const response = await apiClient.post<SidebarMenu>(
      "/sidebar-menu/menus",
      data,
    );
    return response.data;
  },

  async deleteMenu(menuId: string): Promise<void> {
    await apiClient.delete(`/sidebar-menu/menus/${menuId}`);
  },
  async updateMenu(
    menuId: string,
    data: CreateMenuRequest,
  ): Promise<SidebarMenu> {
    const response = await apiClient.put<SidebarMenu>(
      `/sidebar-menu/menus/${menuId}`,
      data,
    );
    return response.data;
  },
};
